
(function(){
  var REVIEWS = [
    {label:'Sunset Cirrus',src:'g',srcName:'Google',name:'Ethan Pilon',meta:'Google · Oct 2024',text:'I did a sunset flight and Alex let us fly. The website was easy to book and the Cirrus was really fun to fly — some of the coolest views I’ve ever seen. 10/10 would fly with them again!'},
    {label:'Teen First Lesson',src:'g',srcName:'Google',name:'Tania Anders',meta:'Google · Jun 2025',text:'We gifted our teenage son his first flying lesson. Alex greeted us and gave a reassuring brief that made us all feel at ease — confident, clear and very professional. He was so excited!'},
    {label:'Simulators',src:'g',srcName:'Google',name:'George Attallah',meta:'Google · Apr 2024',text:'Very professional and great airplanes. I love the flight simulators, and the pricing is very fair compared to any other flight school in the area.'},
    {label:'PPL Student',src:'g',srcName:'Google',name:'Nazanin Jalalian',meta:'Google · Dec 2025',text:'I couldn’t be happier with my experience. I got my Private Pilot License here and I’m now working on my Instrument Rating. My instructor Joseph was patient, knowledgeable and absolutely amazing.'},
    {label:'Family Flight',src:'g',srcName:'Google',name:'Sanaz D.',meta:'Google · 2025',text:'I got two discovery flights for my kids. Alex made sure they felt comfortable and let them take the controls with his help. The Cirrus was amazing — I definitely recommend this school!'},
    {label:'Surprise Flight',src:'g',srcName:'Google',name:'Rakkad A.',meta:'Google · 2024',text:'Last-minute booking to surprise my wife. She was scared of flying, but Alex was easygoing and knew how to make her enjoy her first flight. Highly recommend.'},
    {label:'Discovery Flight',src:'g',srcName:'Google',name:'Mena M.',meta:'Google · 2025',text:'An amazing experience from start to finish. Flying the Diamond over LA, Hollywood and Malibu — the views and the feel of the controls were just awesome.'}
  ];

  function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
  function initials(n){ return String(n).trim().split(/\s+/).map(function(w){return w[0]}).join('').slice(0,2).toUpperCase(); }
  var STARS='★★★★★';

  function cardHTML(r){
    return '<article class="la-rs-card">'
      + '<div class="la-rs-ctop"><span class="la-rs-label">'+esc(r.label)+'</span><span class="la-rs-src '+r.src+'">'+esc(r.srcName)+'</span></div>'
      + '<span class="la-rs-cstars">'+STARS+'</span>'
      + '<blockquote>'+esc(r.text)+'</blockquote>'
      + '<div class="la-rs-person"><span class="la-rs-av" aria-hidden="true">'+esc(initials(r.name))+'</span><span><b>'+esc(r.name)+'</b><em>'+esc(r.meta)+'</em></span></div>'
      + '<div class="la-rs-foot"><span>Los Angeles Flight School · VNY</span><span class="la-rs-verified">✓ Verified</span></div>'
      + '</article>';
  }

  function buildSection(){
    var cards = REVIEWS.map(cardHTML).join('');
    var sec = document.createElement('section');
    sec.className = 'la-revswap';
    sec.setAttribute('data-la-revswap','1');
    sec.innerHTML =
      '<div class="la-rs-inner"><div class="la-rs-head">'
      + '<p class="la-rs-eyebrow">Reviews</p>'
      + '<h2 class="la-rs-h2">Loved By Students Across LA</h2>'
      + '<div class="la-rs-rating"><span class="la-rs-stars">'+STARS+'</span><b>5.0</b><span>· 120+ Google reviews</span></div>'
      + '</div></div>'
      + '<div class="la-rs-car"><div class="la-rs-track">'+cards+cards+'</div></div>';
    return sec;
  }

  // A reputon widget only counts if Reputon has actually rendered reviews into it
  // (visible + real height). Empty/latent embeds — e.g. the copy in the global
  // footer that never populates — are ignored so we never inject a phantom carousel.
  function isRendered(el){
    if(!el || el.offsetParent === null) return false;
    return el.getBoundingClientRect().height > 40;
  }
  function findBlocks(){
    var widgets = document.querySelectorAll('.reputon-google-reviews-widget, .reputon-reviews-holder, .reputon-reviews-count');
    var blocks = [];
    for(var i=0;i<widgets.length;i++){
      var w = widgets[i];
      if(!isRendered(w)) continue;
      var block = w.closest('.gp-custom-code') || w.parentElement;
      if(block && blocks.indexOf(block)===-1) blocks.push(block);
    }
    return blocks;
  }

  var inserted = false;
  function run(){
    var blocks = findBlocks();
    var acted = false;
    for(var i=0;i<blocks.length;i++){
      var b = blocks[i];
      if(b.getAttribute('data-la-revswap-handled')) continue;
      b.setAttribute('data-la-revswap-handled','1');
      if(!inserted){
        var sec = buildSection();
        b.parentNode.replaceChild(sec, b);
        inserted = true;
      } else {
        b.style.display = 'none';   // extra visible legacy widget on same page — hide, no duplicate carousel
      }
      acted = true;
    }
    return acted;
  }

  function boot(){
    run();
    // Reputon / GemPages hydrate asynchronously — keep watching so a widget that
    // renders late still gets swapped; stop after ~12s.
    var tries = 0;
    var iv = setInterval(function(){
      tries++;
      run();
      if(tries > 48){ clearInterval(iv); }
    }, 250);
    if('MutationObserver' in window){
      var mo = new MutationObserver(function(){ run(); });
      mo.observe(document.documentElement,{childList:true,subtree:true});
      setTimeout(function(){ mo.disconnect(); clearInterval(iv); }, 12000);
    }
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
